import { InjectionToken } from '@angular/core';

export const ICON_TOKEN = new InjectionToken('ICON_TOKEN');
